import { render } from "./finacialEnding.vue?vue&type=template&id=0066ffb2"
import script from "./finacialEnding.vue?vue&type=script&lang=ts"
export * from "./finacialEnding.vue?vue&type=script&lang=ts"
script.render = render

export default script